// @vendors
import { useContext, useState, useEffect } from "react";
import { Form, Modal } from "antd";
import InputMask from "react-input-mask";
import Context from "../../../context/appContext";
import moment from "moment";
import { formatDate, getDate, getValueField } from "utils/utils";
import { infoRFC } from "__test__/components/fields/text/data.mock";
const momentT = require("moment-timezone");

export default function DateMaskField({ info, key, form, current }) {
  const validate = info.validate ? info.validate : {};
  const {
    dataForm: { formResponses, hiddenFields, disabledFields },
    setIsClean,
    setShowAlert,
    setExecuteCoverage,
    setTypePerson,
  } = useContext(Context);
  const [message, setMessage] = useState({ help: "", status: "success" });
  const [age, setAge] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [today, setToday] = useState("");
  const [laterDate, setLaterDay] = useState("");
  useEffect(() => {
    getDefaultValue();
  }, []);

  const keysValidate = {
    fechaNacimientoContratante: true,
    fechaDeConstitucionContratante: true,
    fechaApartirDe: true,
    fechaHasta: true,
  };

  const keyNames = {
    fechaNacimientoAsegurado: "fechaNacimientoAsegurado",
  };

  const keyValidateDate = {
    fechaNacimientoContratante: true,
    fechaDeConstitucionContratante: true,
  };
  useEffect(() => {
    disabledFields[info.key] && getDefaultValue();
    if (info.key === "fechaDeConstitucionContratante")
      setMessage({ help: "", status: "success" });
  }, [disabledFields[info.key]]);

  const validateDate = (event) => {
    let value = event.target.value.replace("_", "");
    if (moment(value, info.format, true).isValid()) {
      const ranges = { ...(info && info.datePicker) };
      ranges["maxDate"] = Number(ranges.maxDate);
      ranges["minDate"] =
        ranges && (!Number(ranges.minDate) || Number(ranges.minDate) == 0)
          ? new Date(moment().format("YYYY-MM-DD")).getTime()
          : Number(ranges.minDate);
      if (value.length === info.format.length) {
        value = moment(value, info.format).format("YYYY-MM-DD");
        const inputDate = getDate(value); // se obtienen la edad en años
        if (inputDate <= ranges.maxDate && inputDate >= ranges.minDate) {
          setAge(`${inputDate} años`);
          successField(info, value);
        } else {
          setAge("");
          setMessage({ help: "", status: "success" });
          if (!keysValidate[info.key]) {
            setShowAlert({
              renderMessage: {
                title: "Ops!",
                body: "Lo sentimos, debes ser mayor de edad para cotizar el seguro de auto",
              },
            });
            setMessage({ help: validate.customMessage, status: "error" });
          }
          if (keyValidateDate[info.key]) {
            const inputDateInMS = !Number(info.datePicker.minDate) ? 0 : Number(info.datePicker.minDate)
            const date = Date.parse(value);
            const currentDate = Date.parse(moment().format("YYYY-MM-DD"));
            if ( date < currentDate && inputDate <= ranges.maxDate && inputDate >= inputDateInMS) {
              successField(info, value);
            } else {
              setMessage({ help: validate.customMessage, status: "error" });
            }
          }
          if (info.key === "fechaApartirDe") {
            validateDateVigencia(value);
          }
        }
      }
    } else {
      setAge("");
      setMessage({ help: validate.customMessage, status: "error" });
    }
  };

  const validateDateVigencia = (value) => {
    const values = Date.parse(moment(value).format("YYYY-MM-DD"));
    const currentDate = Date.parse(moment(today).format("YYYY-MM-DD"));
    const later = Date.parse(moment(laterDate).format("YYYY-MM-DD"));
    if (values >= currentDate && values <= later) {
      value = moment(value).format("DD/MM/YYYY");
      calculateDateUntil(value);
      successField(info, value);
    } else {
      form.setFieldsValue({ ["fechaHasta"]: "" });
      setMessage({ help: validate.customMessage, status: "error" });
    }
  };

  const successField = (infoS, value) => {
    infoS.value = value;
    const index = formResponses.findIndex((x) => x.key === infoS.key);
    index != -1
      ? (formResponses[index].value = value)
      : formResponses.push(infoS);
    setMessage({ help: "", status: "success" });
  };

  const calculateDateUntil = (currentDate) => {
    let field = "";
    const formatDate = currentDate.split("/");
    const date = `${formatDate[2]}-${formatDate[1]}-${formatDate[0]}`;
    const currentDays = moment(date).format("YYYY-MM-DD");
    const UntilDate = moment(currentDays)
      .add(12, "months")
      .format("DD/MM/YYYY");
    form.setFieldsValue({ ["fechaHasta"]: UntilDate });
    disabledFields["fechaHasta"] = true;
    if (current && current.newItems.length) {
      field = current.newItems.find((e) => e.key === "fechaHasta");
    }
    successField(field ? field : { key: "fechaHasta" }, UntilDate);
  };

  const getDefaultValue = () => {
    const chkData = formResponses.find(
      (item) => item.key === "datosContratanteIgualAsegurado"
    );
    const hasCheckLoadLastStepInfo = current.newItems.find(
      (x) => x && x.key === "datosContratanteIgualAsegurado"
    );

    if (info.key === "fechaNacimiento") {
      setExecuteCoverage("");
    }

    let value = "";
    if (
      info.customDefaultValue &&
      (!hasCheckLoadLastStepInfo ||
        (hasCheckLoadLastStepInfo && chkData && chkData.value))
    ) {
      const item = formResponses.find((x) => x.key === info.customDefaultValue);
      value = moment(item && item.value ? item.value : "").format("DD/MM/YYYY");
      disabledFields[info.key] = true;
    } else if (info && info.value && info.value !== null && info.value !== "") {
      value = moment(info.value).format("DD/MM/YYYY");
    }
    if (
      info.key === "fechaNacimientoAsegurado" ||
      info.key === "fechaDeConstitucionContratante"
    ) {
      if (keyNames[info.key]) {
        const valueItem = getValueField(keyNames[info.key], formResponses);
        if (valueItem) {
          value = moment(valueItem).format("DD/MM/YYYY");
          form.setFieldsValue({ [info.key]: valueItem });
        }
      }
      const dateValue = form.getFieldValue(info.key);
      if (!dateValue) {
        const item = formResponses.find((x) => x.key === "fechaNacimiento");
        value = moment(item && item.value ? item.value : "").format(
          "DD/MM/YYYY"
        );
      }
      disabledFields[info.key] = true;
    }
    if (value && value !== "") {
      const valueField = form.getFieldValue(info.key);
      if (info.key === "fechaHasta" && valueField) {
        const formatDate = valueField.split("/");
        value = moment(
          `${formatDate[1]}/${formatDate[0]}/${formatDate[2]}`
        ).format("DD/MM/YYYY");
      }
      form.setFieldsValue({ [info.key]: value });
      validateDate({ target: { value: value } });
    }
    if (info.key === "fechaNacimiento" && !value) {
      const valueField = form.getFieldValue(info.key);
      if (valueField) {
        validateDate({ target: { value: valueField } });
      }
    }
    if (info.key === "fechaApartirDe") {
      setIsClean(true);
      setTypePerson(false);
      let currentDate = momentT()
        .tz("America/Mexico_City")
        .format("YYYY-MM-DD");
      const hour = momentT().tz("America/Mexico_City").format("HH");
      /*if (hour >= 12) {
        currentDate = moment(currentDate).add(1, "days").format("DD/MM/YYYY");
        form.setFieldsValue({ [info.key]: currentDate });
        setAlertMessage(
          "A partir de las 12pm las polizas son emitidas con fecha del día siguiente"
        );
      } else {*/
        currentDate = moment(currentDate).format("DD/MM/YYYY");
        form.setFieldsValue({ [info.key]: currentDate });
      //}
      const updateCurrentDate = formatDate(currentDate, "/");
      const later = moment(updateCurrentDate)
        .add(30, "days")
        .format("DD/MM/YYYY");
      setLaterDay(formatDate(later, "/"));
      setToday(updateCurrentDate);
      successField(info, currentDate);
      calculateDateUntil(currentDate);
    }
  };

  return (
    <>
      <div className={hiddenFields[info.key] && "ant-form-item-hidden"}>
        <Form.Item
          label={info.label}
          name={info.key}
          key={key}
          hidden={hiddenFields[info.key]}
          rules={[
            {
              required:
                hiddenFields[info.key] ||
                disabledFields[info.key] ||
                info.disabled
                  ? false
                  : validate.required,
              message: "Campo obligatorio",
            },
            {
              pattern: new RegExp(message.status === "error" ? "error" : ""),
              message: message.help,
            },
          ]}
        >
          <InputMask
            className="ant-input"
            mask={info.format.replace(/[dDMYyhHmS]/g, "9")}
            placeholder={info.format}
            disabled={disabledFields[info.key]}
            onChange={validateDate}
          ></InputMask>
        </Form.Item>
        {!disabledFields[info.key] &&
          info.key != "fechaNacimientoContratante" && (
            <div className="datepicker-age">{age}</div>
          )}
        {info.key === "fechaApartirDe" && alertMessage && (
          <div className="datepicker-age">{alertMessage}</div>
        )}
      </div>
    </>
  );
}
